__turbopack_context__.v({
  "suggestions-title": "SuggestionsSection-module-scss-module__USzFiW__suggestions-title",
});
